import React from 'react';
import Icon from '../../../components/icon';
import {Column, Row} from '../../../components/layout';
import {Icons} from '../../../util/icons';
import * as fonts from '../../../util/fonts';

export interface StatusProps {
  stateDescription: string | undefined;
  color: string | undefined;
}

function PreAuthorizationListItemStatus(props: StatusProps) {
  return (
    <Row>
      <Column
        className="reimbursement-history-list-item-status-label"
        style={{
          ...fonts.SM,
          textAlign: 'right',
          fontSize: '11px !important',
          color: '#8E8E8E',
          fontWeight: 'bold',
        }}>
        {props.stateDescription?.toUpperCase()}
      </Column>
      <Column className="reimbursement-history-list-item-status-indicator-column">
        <Icon
          className="reimbursement-history-list-item-status-indicator"
          name={Icons.STATUS_INDICATOR}
          color={props.color}
          width="16"
          height="16"
          changeViewbox 
          viewBox={'0 0 24 24'}
        />
      </Column>
    </Row>
  );
}

export default PreAuthorizationListItemStatus;
